import { application } from "./application";

const controllerModules = import.meta.glob("./**/*_controller.js", { eager: true });
for (const controllerPath in controllerModules) {
  application.register(
    controllerPathToStimulusIdentifier(controllerPath),
    controllerModules[controllerPath].default
  );
}

/**
 * +-------------------------------------+---------------------------+
 * | If your controller file is named... | its identifier will be... |
 * +-------------------------------------+---------------------------+
 * | clipboard_controller.js             | clipboard                 |
 * | date_picker_controller.js           | date-picker               |
 * | users/list_item_controller.js       | users--list-item          |
 * +-------------------------------------+---------------------------+
 */
function controllerPathToStimulusIdentifier(filePath) {
  return filePath.match(/^\.\/(.+)_controller\.js$/)[1].replaceAll("_", "-").replaceAll("/", "--");
}
